import { SchoolIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import type { GradeOption } from '../hooks/useGradeOptions';
import { FilterDropdown } from './FilterDropdown';

/**
 * 학년 필터 드롭다운 컴포넌트
 * schoolInfoTree를 기반으로 동적으로 학년 그룹 생성
 * 초등: 1-2, 3-4, 5-6 / 중등: 1~3 / 고등: 1~3
 */
export const GradeFilter = ({
  value,
  options,
  onChange,
  open,
  onOpenChange
}: {
  value: GradeOption | null;
  options: GradeOption[];
  onChange: (value: GradeOption) => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const label = value?.label || String(t('build.standard.grade.placeholder'));
  // ids가 빈 배열이면 "전체 학년" (ids.length 비교는 객체 참조와 무관하게 안정적)
  const hasValue = value !== null && value.ids.length > 0;
  const filterOptions = options.map(option => ({
    // "전체 학년"(ids:[])은 고정 key 'all', 나머지는 ids 조합으로 고유 key 생성
    key: option.ids.length > 0 ? option.ids.join('-') : 'all',
    label: option.label,
    // ids 내용 비교 (객체 참조 비교는 gradeOptions 재생성 시 불안정)
    isSelected: value !== null && option.ids.join('-') === value.ids.join('-'),
    onSelect: () => onChange(option)
  }));
  return <FilterDropdown label={label} hasValue={hasValue} icon={<SchoolIcon size="xs" />} options={filterOptions} onClear={() => onChange(options[0])} open={open} onOpenChange={onOpenChange} data-sentry-element="FilterDropdown" data-sentry-component="GradeFilter" data-sentry-source-file="GradeFilter.tsx" />;
};